export default "__VITE_ASSET__4bba33e3__"